import { render, staticRenderFns } from "./SynonymItem.vue?vue&type=template&id=4dc55df6"
import script from "./SynonymItem.vue?vue&type=script&lang=js"
export * from "./SynonymItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports